

const shippingpolicy = () => {

  return (
      <div>
          <section>
              <div className="container">
                  <div className="row">
                      <div className="col-md-12 my-5 pt-2 text-muted">
                          <h2 className="text-primary mb-3">Shipping Policy</h2>
                          <p className=""><li>For orders booked till 10:00 pm will be accommodated on the same day and shipped to your doorstep within 1-3 hours. Orders will be catered 7 days a week (Monday- Sunday).</li></p>
                          <p><li>For Mega stores, Orders booked till 11:00 pm will be accommodated on the same day and shipped to your door step within 1-2 working days. Orders will be catered 6 days a week (Monday-Saturday)</li></p>
                          <p><li>Shipping is Free across Pakistan .</li></p>
                      </div>
                  </div>
              </div>
          </section>
      </div>
  )
}

export default shippingpolicy
